import { FC } from 'react';
import { Col, Row } from 'antd';
import Explore from '@mui/icons-material/Explore';
import Visibility from '@mui/icons-material/Visibility';
import { TitleSection } from '../../../components/title-sections/title-sections';
import { IJourney } from '../../../apis/journeys';
import { JourneyCard } from '../../journeys/journey-card/journey-card';

export interface CitizenJourneyProps {
  journeys?: IJourney[];
  onClickJourney: (slug: string) => void;
  onClickSeeAll: () => void;
}

export const CitizenJourney: FC<CitizenJourneyProps> = ({
  journeys,
  onClickJourney,
  onClickSeeAll,
}) => {
  if (!journeys?.length) return null;

  return (
    <div className="xvia-citizen-journey">
      <TitleSection
        titleSettings={{
          title: 'Jornada do Cidadão',
          colorTitle: '#202020',
          subtitle:
            'Os serviços que você precisa, na ordem em que você precisa deles',
          colorSubtitle: '#7B7B7B',
        }}
        iconSettings={{
          displayIcon: true,
          sectionIcon: <Explore />,
          iconColor: '#9E9E9E',
          iconSize: '40px',
        }}
        buttonSeeMoreSettings={{
          buttonLabel: 'Ver todas',
          buttonIcon: <Visibility />,
          onClick: onClickSeeAll,
        }}
      />
      <Row gutter={[24, 24]}>
        {journeys.map((journey) => (
          <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8} key={journey.id}>
            <JourneyCard journey={journey} onClick={onClickJourney} />
          </Col>
        ))}
      </Row>
    </div>
  );
};
